const information = [{
    name: "nom",
    label: "Nom de frais *",
    params: { required: true } 
}]

export {
    information
};